import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { api } from '../api/client';

type Status = 'verifying' | 'success' | 'failed';

export default function VerifyPage() {
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';
  const [status, setStatus] = useState<Status>('verifying');
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!token) {
      setStatus('failed');
      setError('Missing verification token.');
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        await api.verifyEmail(token);
        if (!cancelled) setStatus('success');
      } catch (err) {
        if (cancelled) return;
        setStatus('failed');
        setError(err instanceof Error ? err.message : 'Verification failed.');
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [token]);

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h1>
          {status === 'verifying' && 'Verifying…'}
          {status === 'success' && 'Email verified'}
          {status === 'failed' && 'Verification failed'}
        </h1>
        <div className="sub">Revenue Estimator</div>
        {status === 'verifying' && (
          <p className="auth-text">Just a moment.</p>
        )}
        {status === 'success' && (
          <>
            <p className="auth-text">
              Your account is now active. You can sign in.
            </p>
            <div className="foot-link">
              <Link to="/login">Go to sign in</Link>
            </div>
          </>
        )}
        {status === 'failed' && (
          <>
            {error && <div className="error-banner">{error}</div>}
            <p className="auth-text muted">
              The link may have expired or already been used. You can
              request a new one from the sign-in page.
            </p>
            <div className="foot-link">
              <Link to="/login">Go to sign in</Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
